import { DoqFaceSvgProps } from '../types';

const DependencyMapError = ({ size, className }: DoqFaceSvgProps) => (
  <svg
    width={size}
    height={size}
    className={className}
    viewBox="0 0 320 320"
    fill="none"
    role="presentation"
  >
    <g clipPath="url(#clip0_2866_49197)">
      {/* mask to hide the bottom outline of the circle */}
      <mask id="bottom-mask-dependency-map-error">
        <circle cx="160" cy="160" r="160" fill="white" />
        <path d="M 240,300 A 160,160 0 0,1 80,300 L 160,160 Z" fill="black" />
      </mask>
      <circle
        cx="160"
        cy="160"
        r="160"
        fill="#FCBF4C"
        mask="url(#bottom-mask-dependency-map-error)"
      />

      <mask
        id="mask0_2866_49197"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="320"
        height="320"
      >
        <circle cx="160" cy="160" r="160" fill="#FCBF4C" />
      </mask>
      <g mask="url(#mask0_2866_49197)">
        <rect x="80" y="120" width="160" height="200" fill="white" />
      </g>
      <path
        d="M142 184C146.418 184 150 180.418 150 176C150 171.582 146.418 168 142 168C137.582 168 134 171.582 134 176C134 180.418 137.582 184 142 184Z"
        fill="#2E0057"
      />
      <path
        d="M178 184C182.418 184 186 180.418 186 176C186 171.582 182.418 168 178 168C173.582 168 170 171.582 170 176C170 180.418 173.582 184 178 184Z"
        fill="#2E0057"
      />
      <g opacity="0.5">
        <path
          d="M88 240.25C88 235.832 91.5817 232.25 96 232.25H224C228.418 232.25 232 235.832 232 240.25V296.25C232 300.668 228.418 304.25 224 304.25H96C91.5817 304.25 88 300.668 88 296.25V240.25Z"
          fill="#4C008F"
        />
        <path
          d="M104.16 256C104.16 251.582 107.741 248 112.16 248H208.375C212.793 248 216.375 251.582 216.375 256C216.375 260.418 212.793 264 208.375 264H112.16C107.741 264 104.16 260.418 104.16 256Z"
          fill="white"
        />
        <path
          d="M112.16 271.967C107.741 271.967 104.16 275.549 104.16 279.967C104.16 284.385 107.741 287.967 112.16 287.967H128.25C132.668 287.967 136.25 284.385 136.25 279.967C136.25 275.549 132.668 271.967 128.25 271.967H112.16Z"
          fill="white"
        />
        <path
          d="M183.877 280.183C183.877 275.764 187.459 272.183 191.877 272.183H207.968C212.386 272.183 215.968 275.764 215.968 280.183C215.968 284.601 212.386 288.183 207.968 288.183H191.877C187.459 288.183 183.877 284.601 183.877 280.183Z"
          fill="white"
        />
        <path
          d="M152.222 272.183C147.804 272.183 144.222 275.764 144.222 280.183C144.222 284.601 147.804 288.183 152.222 288.183H168.312C172.731 288.183 176.312 284.601 176.312 280.183C176.312 275.764 172.731 272.183 168.312 272.183H152.222Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M94.75 248.061C94.75 243.09 98.7794 239.061 103.75 239.061H216.25C221.221 239.061 225.25 243.09 225.25 248.061V288.648C225.25 293.619 221.221 297.648 216.25 297.648H103.75C98.7794 297.648 94.75 293.619 94.75 288.648V248.061ZM103.75 241.061C99.884 241.061 96.75 244.195 96.75 248.061V288.648C96.75 292.514 99.884 295.648 103.75 295.648H216.25C220.116 295.648 223.25 292.514 223.25 288.648V248.061C223.25 244.195 220.116 241.061 216.25 241.061H103.75Z"
          fill="white"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M160.851 200.005C159.816 200.082 159 200.946 159 202C159 203.105 159.895 204 161 204H175.5C177.433 204 179 205.567 179 207.5C179 207.67 178.988 207.837 178.964 208.001L179 208.001C179.001 209.105 179.896 210 181 210C182.105 210 183 209.105 183 208C183 207.942 182.997 207.884 182.993 207.826L182.984 208.001C182.994 207.835 183 207.668 183 207.5C183 203.358 179.642 200 175.5 200H161L160.851 200.005Z"
        fill="#2E0057"
      />
      <path
        d="M160 58.0031C119.891 57.6641 84.9485 85.5337 76 125H244C235.051 85.5337 200.109 57.6641 160 58.0031Z"
        fill="#BB58BC"
      />
      <path d="M68 125H252V158H68V125Z" fill="#770079" />
      <path d="M157.332 92H150V98.999H157.332V92Z" fill="white" />
      <path d="M172 106.001H150V113H172V106.001Z" fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_2866_49197">
        <rect width="320" height="320" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export { DependencyMapError };
